import type { BookingsOverviewData } from '../../domain/types'
import type { BookingsOverviewAPIResponse } from '../types'
import { mapCancelledBookings } from './cancelledBookings'
import { mapPastBookings } from './pastBookings'
import { mapUpcomingBookings } from './upcomingBookings'

export function bookingsOverviewMapper(apiResponse: BookingsOverviewAPIResponse): BookingsOverviewData {
  return {
    cancelledBookings: mapCancelledBookings(apiResponse),
    pastBookings: mapPastBookings(apiResponse),
    upcomingBookings: mapUpcomingBookings(apiResponse, new Date()),
  }
}
